'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.siteHeader =
  twentyninetimes.siteHeader ||
  (function () {
    const floatingCallBtns = document.querySelector('#phonefloatercontent')

    var doc = document.documentElement
    var w = window

    var prevScroll = w.scrollY || doc.scrollTop
    var curScroll
    var direction = 0
    var prevDirection = 0

    var header = document.getElementById('js-site-header'),
      header_height = header.clientHeight

    function init() {
      if (header) {
        toggleHeader(header)
      }
    }

    function checkScroll() {
      /*
       ** Find the direction of scroll
       ** 0 - initial, 1 - up, 2 - down
       */

      curScroll = w.scrollY || doc.scrollTop

      curScroll > header_height
        ? header.classList.add('scrolled')
        : header.classList.remove('scrolled')

      if (curScroll > prevScroll) {
        //scrolled up
        direction = 2
      } else if (curScroll < prevScroll) {
        //scrolled down
        direction = 1
      }

      if (direction !== prevDirection) {
        toggleHeader(direction, curScroll)
      }

      prevScroll = curScroll
    }

    function toggleHeader(direction, curScroll) {
      if (direction === 2 && curScroll > header_height) {
        document.body.classList.add('scrolled-down')
        floatingCallBtns?.classList?.add('hide')
        prevDirection = direction
      } else if (direction === 1) {
        document.body.classList.remove('scrolled-down')
        floatingCallBtns?.classList?.remove('hide')
        prevDirection = direction
      }
    }

    return {
      init: init,
      checkScroll: checkScroll,
    }
  })()
